import { ModelApiService } from './BaseApiService'

export default class CandidateApiService extends ModelApiService {
  constructor() {
    super('candidate')
  }

  async getCandidateDetails(id) {
    return this.get(`${id}/details`)
  }

  async queryCandidates(payload) {
    return await this.post('queryCandidates', payload)
  }

  async getBookableEducators(payload) {
    return await this.post('bookable', payload)
  }

  getCandidateListByClientIds(clientIds = []) {
    return this.post(`candidatelist`, {
      clientIds,
    })
  }

  async getDisplayPic(id, options = {}) {
    if (id && id >= 0) {
      const headers = {}
      if (options.signal) {
        headers.signal = options.signal
      }
      return this.get(`${id}/profile-image`, null, headers)
    }
  }

  async getCandidates(payload) {
    return await this.post('candidates', payload)
  }

  async getCandidateListCertifications(clientIds = []) {
    return await this.post('certifications', { clientIds })
  }

  async getCandidateListTypes(clientIds = []) {
    return await this.post('types', { clientIds })
  }

  async exportCandidates(
    locationIds,
    startDate,
    endDate,
    format,
    useACECQATemplate
  ) {
    const payload = {
      locationIds,
      startDate,
      endDate,
      format,
      useACECQATemplate,
    }

    if (format === 'Excel' || format === 'Csv') {
      return await this.postBlob('workplace-register/export', payload)
    }

    return await this.post('workplace-register/export', payload)
  }
}
